<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
        :method-delete-row="methods.deleteRow"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import { getMacroregions, deleteMacroregion as deleteRow } from "@/api/regions";

const columnsOptions = {
  sortable: "custom",
  controls: {
    width: 270,
  },
  edit: true,
  id: "id",
  delete_row: {
    buttonName: "Удалить",
    confirm: true,
  },
};

const columns = [
  {
    prop: "id",
    label: "ID",
  },
  {
    prop: "name",
    label: "Название региона",
  },
];

const midFunc = async (query, params) => {
  const data = await getMacroregions(query, params);
  return data.macroregions;
};

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        fetchData: midFunc,
        deleteRow,
      },
    };
  },
};
</script>
